import graphqlClient from "../../../apollo";

class CompararPreciosProveedorProvider {
  compararPreciosProveedor(proveedorId, depositoId, rows) {
    return graphqlClient.query({
      query: require("./gql/compararPreciosProveedor.graphql"),
      variables: { proveedorId, depositoId, rows },
      fetchPolicy: "network-only",
    });
  }

  aplicarComparacionPreciosProveedor(proveedorId, depositoId, items) {
    return graphqlClient.mutate({
      mutation: require("./gql/aplicarComparacionPreciosProveedor.graphql"),
      variables: { proveedorId, depositoId, items },
    });
  }
}

export default new CompararPreciosProveedorProvider();
